module.exports = __webpack_public_path__ + "static/side-38676818a36b791e2d3db092157170a8.svg";